<script>
  export let icon;
</script>


{#if icon === 'arrow'}
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="50" height="50" viewBox="0 0 50 50">
    <defs>
      <clipPath id="clip-Arrow">
        <rect width="50" height="50"/>
      </clipPath>
    </defs>
    <g id="Arrow" clip-path="url(#clip-Arrow)">
      <rect width="50" height="50" fill="#fff"/>
      <path id="Path_3352" data-name="Path 3352" d="M-13857.082-17394.9l-1.295-1.35,10.391-9.984.646.674,8.963,9.34-1.348,1.291-8.316-8.664Z" transform="translate(-13823.377 -17375.898) rotate(180)"/>
    </g>
  </svg>
{/if}
